import { ajax } from 'discourse/lib/ajax';
import DiscourseRoute from 'discourse/routes/discourse';

export default class ProxyviewsCompareRoute extends DiscourseRoute {
  async model() {
    // This is a full-catalog picker (not a paginated listing), so ask the
    // backend for the max page size it allows rather than the default page-1
    // slice — otherwise providers past the default per-page limit are
    // silently missing from the comparison dropdown.
    const data = await ajax('/providers.json', {
      data: { per_page: 100 },
    });
    const providers = (data.providers || [])
      .map((p) => p.provider || p)
      .map((p) => ({ slug: p.slug, name: p.name }));
    return { providers };
  }

  titleToken() {
    return 'Compare Proxy Providers';
  }
}
